<section class="footer-copyright">
  <p>© Copyright <strong>aqtca</strong> {{ year }}</p>
</section>
